export const ModalContractPage = {
  CONTRACT_HISTORY: 'CONTRACT_HISTORY',
  CREATE_NEW_CONTRACT: 'CREATE_NEW_CONTRACT',
  READ_AND_SIGN_NEW_CONTRACT: 'READ_AND_SIGN_NEW_CONTRACT',
  READ_AND_SIGN_CONTRACT: 'READ_AND_SIGN_CONTRACT',
  READ_CONTRACT_ONLY: 'READ_CONTRACT_ONLY',
  CREATE_SIGN_IMAGE: 'CREATE_SIGN_IMAGE',
  METHOD_OF_SIGNING: 'METHOD_OF_SIGNING',
  CONFIRM_PERSONAL_INFO: 'CONFIRM_PERSONAL_INFO',
  CONTRACT_SIGNED: 'CONTRACT_SIGNED',
  READ_CONTRACT_WITHOUT_FOOTER: 'READ_CONTRACT_WITHOUT_FOOTER',
} as const;

export const ModalContractReadPage: Array<keyof typeof ModalContractPage> = [
  ModalContractPage.READ_AND_SIGN_NEW_CONTRACT,
  ModalContractPage.READ_AND_SIGN_CONTRACT,
  ModalContractPage.READ_CONTRACT_ONLY,
  ModalContractPage.READ_CONTRACT_WITHOUT_FOOTER,
];

export enum SignatureTabs {
  DIGIT = 'DIGIT',
  DRAW = 'DRAW',
  UPLOAD = 'UPLOAD',
}
